import {
  Chip,
  Tooltip,
  IconButton,
  Box,
  Typography,
  Button,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { toast } from "../components/Toast/Toast";

export const clientColumns = [
  {
    field: "actions",
    headerName: "Actions",
    width: 50,
    renderCell: (row, onEdit) => (
      <Tooltip title="Edit">
        <IconButton
          size="small"
          onClick={() => onEdit && onEdit(row)}
          className="text-primary hover:bg-primary/10"
        >
          <EditIcon fontSize="small" />
        </IconButton>
      </Tooltip>
    ),
  },
  { field: "id", headerName: "ID", width: 90 },
  {
    field: "name",
    headerName: "Name",
    width: 150,
    editable: true,
  },
  {
    field: "clientId",
    headerName: "Client ID",
    width: 300,
    renderCell: (row) => (
      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <Typography variant="body2" sx={{ fontFamily: "monospace" }}>
          ************************
        </Typography>
        <Tooltip title="Copy Client ID">
          <IconButton
            size="small"
            onClick={(e) => {
              e.stopPropagation();
              navigator.clipboard.writeText(row.clientId);
              toast.success("Client ID copied!");
            }}
            sx={{ color: "primary.main" }}
          >
            <ContentCopyIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      </Box>
    ),
  },
  {
    field: "clientSecret",
    headerName: "Client Secret",
    width: 300,
    renderCell: (row) => (
      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <Typography variant="body2" sx={{ fontFamily: "monospace" }}>
          ************************
        </Typography>
        <Tooltip title="Copy Client Secret">
          <IconButton
            size="small"
            onClick={(e) => {
              e.stopPropagation();
              navigator.clipboard.writeText(row.clientSecret);
              toast.success("Client Secret copied!");
            }}
            sx={{ color: "primary.main" }}
          >
            <ContentCopyIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      </Box>
    ),
  },
  {
    field: "serverURL",
    headerName: "Server URL",
    width: 200,
    editable: true,
  },
  {
    field: "provider",
    headerName: "Provider",
    width: 100,
    editable: true,
  },
  {
    field: "trustedClient",
    headerName: "Trusted",
    renderCell: (row) => (
      <Chip
        label={row.trustedClient ? "Yes" : "No"}
        color={row.trustedClient ? "success" : "default"}
        size="small"
      />
    ),
  },
  {
    field: "activation",
    headerName: "Activation",
    width: 120,
    renderCell: (row, onEdit, onActivate) => (
      <Button
        variant="contained"
        size="small"
        onClick={() => onActivate && onActivate(row)}
        sx={{
          textTransform: "none",
          fontWeight: "bold",
          backgroundColor: "primary.main",
          "&:hover": {
            backgroundColor: "primary.dark",
          },
        }}
      >
        Activate
      </Button>
    ),
  },
];

export const providerTypes = [
  {
    value: "modivcare",
    label: "Modivcare",
  },
  {
    value: "iehp",
    label: "IEHP",
  },
  {
    value: "ctc",
    label: "Call the Car",
  },
  {
    value: "phpca",
    label: "PHPCA",
  },
  {
    value: "rippling",
    label: "Rippling",
  },
  {
    value: "mtm",
    label: "MTM",
  },
];
